import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitDiagnosis({ description, vehicle, whenOccurs, warningLights, audioBlob }) {
  const fd = new FormData();
  fd.append("description", description || "");
  fd.append("vehicle_year", vehicle?.year || "");
  fd.append("vehicle_make", vehicle?.make || "");
  fd.append("vehicle_model", vehicle?.model || "");
  fd.append("when_occurs", whenOccurs || "");
  fd.append("warning_lights", (warningLights || []).join(","));
  if (audioBlob) {
    const ext = audioBlob.type.includes("webm") ? "webm" : "mp3";
    fd.append("audio", audioBlob, `engine.${ext}`);
  }
  const { data } = await api.post("/diagnose", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return data;
}

export async function fetchMechanics(params = {}) {
  const { data } = await api.get("/mechanics", { params });
  return data;
}

export async function fetchTowTrucks(params = {}) {
  const { data } = await api.get("/tow-trucks", { params });
  return data;
}
